
const CellDCTcVinNumber: React.FC<{ data: any }> = ({ data }) => {

    return (
        <>{data['car_tc_number']}<br /><>{data['car_vin_number']}</></>
    )
}

export default CellDCTcVinNumber;